import Qs from "qs";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

/**
 * Remove a parameter from the URL by name.
 * @returns Function to remove a parameter.
 */
export const useRemoveUrlParameter = () => {
    const { push } = useHistory();

    /**
     * Remove a parameter from the URL.
     * @param parameter Parameter name.
     */
    const removeUrlParameter = useCallback(
        (parameter: string) => {
            const current = Qs.parse(window.location.search, { ignoreQueryPrefix: true });
            const { [parameter]: currentValue, ...otherParameters } = current;
            push({ search: Qs.stringify(otherParameters, { addQueryPrefix: true }) });
        },
        [push]
    );

    return removeUrlParameter;
};
